import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts'

// Sample data - in production, this would come from analytics
const sampleData = [
    { phrase: 'at the end of the day', count: 24, severity: 'high' },
    { phrase: 'think outside the box', count: 18, severity: 'high' },
    { phrase: 'low-hanging fruit', count: 15, severity: 'high' },
    { phrase: 'game-changer', count: 12, severity: 'medium' },
    { phrase: 'circle back', count: 10, severity: 'medium' },
    { phrase: 'deep dive', count: 8, severity: 'medium' },
    { phrase: 'best practices', count: 6, severity: 'low' },
]

const severityColors = {
    high: '#ef4444',
    medium: '#eab308',
    low: '#3b82f6',
}

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload
        return (
            <div className="glass-card px-4 py-3 shadow-xl">
                <p className="text-white font-medium mb-1">"{data.phrase}"</p>
                <p className="text-sm text-white/60">
                    Used <span className="font-medium text-white">{data.count}</span> times
                </p>
                <p className="text-sm capitalize" style={{ color: severityColors[data.severity] }}>
                    {data.severity} severity
                </p>
            </div>
        )
    }
    return null
}

export default function ClicheBreakdown({ data }) {
    const chartData = data || sampleData

    return (
        <div className="glass-card p-6">
            <div className="mb-6">
                <h3 className="text-lg font-semibold text-white">Most Common Clichés</h3>
                <p className="text-sm text-white/50">Your frequently used overused phrases</p>
            </div>

            <div className="h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={chartData}
                        layout="vertical"
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" horizontal={false} />
                        <XAxis
                            type="number"
                            stroke="rgba(255,255,255,0.3)"
                            tick={{ fill: 'rgba(255,255,255,0.5)', fontSize: 12 }}
                        />
                        <YAxis
                            type="category"
                            dataKey="phrase"
                            width={150}
                            stroke="rgba(255,255,255,0.3)"
                            tick={{ fill: 'rgba(255,255,255,0.7)', fontSize: 11 }}
                            tickFormatter={(value) => value.length > 20 ? value.substring(0, 20) + '...' : value}
                        />
                        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.05)' }} />
                        <Bar dataKey="count" radius={[0, 4, 4, 0]}>
                            {chartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={severityColors[entry.severity]} fillOpacity={0.8} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Legend */}
            <div className="flex items-center justify-center gap-6 mt-4 pt-4 border-t border-white/10">
                <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-red-500" />
                    <span className="text-sm text-white/60">High</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-yellow-500" />
                    <span className="text-sm text-white/60">Medium</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-blue-500" />
                    <span className="text-sm text-white/60">Low</span>
                </div>
            </div>
        </div>
    )
}
